"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RetailOrderingApp = void 0;
const React = require("react");
const react_router_1 = require("react-router");
const GeoHandler_1 = require("../../../../../handlers/GeoHandler");
const urlParamsToObject_1 = require("../../../../../helpers/urlParamsToObject");
const TickHandler_1 = require("../../../../../components/base/handlers/TickHandler");
const PersistentRetailSession_1 = require("../../../../../features/base/ordering/handlers/PersistentRetailSession");
const RetailLocationsHandler_1 = require("../../../../../features/base/ordering/handlers/RetailLocationsHandler");
const OrderTypeHandler_1 = require("../../../../../features/base/ordering/handlers/OrderTypeHandler");
const ProductsHandler_1 = require("../../../../../features/base/ordering/handlers/ProductsHandler");
const CustomerSalesOrdersHandler_1 = require("../../../../../features/base/ordering/handlers/CustomerSalesOrdersHandler");
const CustomerPaymentMethodHandler_1 = require("../../../../../features/base/ordering/handlers/CustomerPaymentMethodHandler");
const SalesOrderHandler_1 = require("../../../../../features/base/ordering/handlers/SalesOrderHandler");
const RetailCustomerResetPassword_1 = require("../../../../../features/base/ordering/checkout/RetailCustomerResetPassword");
const retailOrderingRoutes_1 = require("./retailOrderingRoutes");
const OrderingErrorHandler_1 = require("../../../../../features/base/ordering/handlers/OrderingErrorHandler");
const FirebaseRetailEventTrackingHandler_1 = require("../../../../../features/base/ordering/handlers/FirebaseRetailEventTrackingHandler");
const FirebaseHandler_1 = require("../../../../../handlers/FirebaseHandler");
const CustomerLocationHandler_1 = require("../../../../../features/base/ordering/handlers/CustomerLocationHandler");
const MarketingHandler_1 = require("../../../../../features/base/ordering/handlers/MarketingHandler");
if (env.deliveryId === undefined) {
    throw new Error("env.deliveryId not set");
}
if (env.serviceId === undefined) {
    throw new Error("env.serviceId not set");
}
const RetailOrderingApp = ({ preselection = {}, children }) => {
    const { prToken, location, locationSlug, orderType } = (0, urlParamsToObject_1.urlParamsToObject)();
    // url params take precedence
    preselection = {
        retailLocationSlug: location ||
            locationSlug ||
            preselection.retailLocationSlug,
        orderType: orderType || preselection.orderType
    };
    // override config specifically for tracking event analytics in  ordering applications
    // there is already firebase configuration set up in the cms but not sure where this points to or what it is tracking so need to have
    // a specific setup for ordering
    const firebaseConfig = {
        firebaseApiKey: env.orderingFirebaseApiKey,
        firebaseAuthDomain: env.orderingFirebaseAuthDomain,
        firebaseDbUrl: env.orderingFirebaseDbUrl,
        firebaseProjectId: env.orderingFirebaseProjectId,
        firebaseStorageBucket: env.orderingFirebaseStorageBucket,
        firebaseMessagingSenderId: env.orderingFirebaseMessagingSenderId,
        firebaseAppId: env.orderingFirebaseAppId,
        firebaseMeasurementId: env.orderingFirebaseMeasurementId
    };
    return (React.createElement(react_router_1.MemoryRouter, null,
        React.createElement(PersistentRetailSession_1.PersistentRetailSession, null,
            React.createElement(FirebaseHandler_1.FirebaseHandler, { overrideConfig: firebaseConfig },
                React.createElement(FirebaseRetailEventTrackingHandler_1.FirebaseRetailEventTrackingHandler, null,
                    React.createElement(TickHandler_1.TickHandler, null,
                        React.createElement(CustomerLocationHandler_1.CustomerLocationHandler, null,
                            React.createElement(RetailLocationsHandler_1.RetailLocationsHandler, { retailLocationSlug: preselection.retailLocationSlug },
                                React.createElement(OrderTypeHandler_1.OrderTypeHandler, { initialOrderType: preselection.orderType },
                                    React.createElement(GeoHandler_1.GeoHandler, null,
                                        React.createElement(ProductsHandler_1.ProductsHandler, null,
                                            React.createElement(CustomerSalesOrdersHandler_1.CustomerSalesOrdersHandler, null,
                                                React.createElement(CustomerPaymentMethodHandler_1.CustomerPaymentMethodHandler, null,
                                                    React.createElement(SalesOrderHandler_1.SalesOrderHandler, null,
                                                        React.createElement(MarketingHandler_1.MarketingHandler, null,
                                                            React.createElement(OrderingErrorHandler_1.OrderingErrorHandler, null, prToken ? (React.createElement(RetailCustomerResetPassword_1.RetailCustomerResetPassword, { token: prToken })) : (React.createElement(React.Fragment, null,
                                                                React.createElement(retailOrderingRoutes_1.RetailOrderingRoutes, null),
                                                                children))))))))))))))))));
};
exports.RetailOrderingApp = RetailOrderingApp;
//# sourceMappingURL=index.js.map